<template>
  <div class="per-detail-main-page">
    <main-header :hasBanner="true" :type="'cygs'"></main-header>
    <section class="main-center list-clr">
      <list-left :type="'cygs'"></list-left>
      <div class="page-right">
        <div class="info-bottom">
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">姓名</div>
              <div class="lab-right">{{ obj.name }}</div>
            </div>
            <div class="lab-item">
              <div class="user-img-box">
                <img class="user-img" :src="obj.userImg" alt="" />
              </div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">从业编码</div>
              <div class="lab-right">{{ obj.code }}</div>
            </div>
            <div class="lab-item"></div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">性别</div>
              <div class="lab-right">{{ obj.sex }}</div>
            </div>
            <div class="lab-item"></div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">毕业院校</div>
              <div class="lab-right">{{ obj.graduatedUniversity }}</div>
            </div>
            <div class="lab-item">
              <div class="lab-left">所学专业</div>
              <div class="lab-right">{{ obj.major }}</div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">毕业日期</div>
              <div class="lab-right">{{ obj.graduationDate }}</div>
            </div>
            <div class="lab-item">
              <div class="lab-left">籍贯</div>
              <div class="lab-right"></div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">联系电话</div>
              <div class="lab-right">{{ obj.phoneNo }}</div>
            </div>
            <div class="lab-item">
              <div class="lab-left">电子邮件</div>
              <div class="lab-right">{{ obj.email }}</div>
            </div>
          </div>

          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">人员诚信码：</div>
              <div class="lab-right">
                <vue-qr :text="mbCode" :size="115" :margin="0"></vue-qr>
              </div>
            </div>

            <div class="lab-item">
              <div class="look-remark" @click="goRemark">查看评价</div>
            </div>
          </div>
        </div>

        <div class="i-r-t">所属经纪机构</div>
        <el-table stripe :data="gsList" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="name"
            label="经纪机构名称"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="districtName"
            label="行政区"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="registeredCapital"
            label="注册资本"
          >
             <template slot-scope="scope">
               <div>{{scope.row.registeredCapital}}<span v-if="scope.row.registeredCapital">万元</span></div>
            </template>
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="address"
            label="企业地址"
          >
          </el-table-column>
          <el-table-column align="centet" header-align="center" label="详细">
            <template slot-scope="scope">
              <img
                @click="goDetail(scope.row)"
                style="width: 20px; cursor: pointer"
                src="@/assets/img/search.png"
                alt=""
              />
            </template>
          </el-table-column>
        </el-table>

        <div class="i-r-t">良好行为记录</div>
        <el-table
          stripe
          :data="(obj && obj.good) || []"
          border
          style="width: 100%"
        >
          <el-table-column
            align="centet"
            header-align="center"
            prop="title"
            label="获奖名称"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="recordDate"
            label="获奖日期"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="points"
            label="积分分值"
          >
          </el-table-column>
        </el-table>

        <div class="i-r-t">不良行为记录</div>
        <el-table
          stripe
          :data="(obj && obj.bad) || []"
          border
          style="width: 100%"
        >
          <el-table-column
            align="centet"
            header-align="center"
            prop="title"
            label="违规名称"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="recordDate"
            label="违规时间"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="points"
            label="扣分分值"
          >
          </el-table-column>
        </el-table>

        <div class="i-r-t">机构人员积分</div>
        <el-table stripe :data="[obj && obj.company && obj.company.totalPoint || {}]" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="start"
            label="开始日期"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="end"
            label="结束日期"
          >
          </el-table-column>
      
          <el-table-column
            align="centet"
            header-align="center"
            prop="totalPoint"
            label="总分"
          >
          </el-table-column>
        </el-table>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import listLeft from "@/components/listLeft";
import { personDetail, personBehavior } from "@/assets/api/person";
import { companyDetail } from "@/assets/api/company";

export default {
  name: "App",
  components: {
    mainHeader,
    mainFooter,
    vueQr,
    listLeft,
  },

  data() {
    return {
      id: this.$route.query.id,
      mbCode: `${this.$globalData.serverUrl}/#/mPersonDetail?id=${this.$route.query.id}`,
      tableData: [],
      obj: "",
      gsList: [],
      goodList: [],
      badList: [],
    };
  },
  computed: {},
  mounted() {
    this.getDetail();
    // this.getBehaviorGood();
    // this.getBehaviorBad();
  },
  methods: {
    goRemark() {
      const jumpUrl = this.$router.resolve({
        path: "/person/remark",
        query: { id: this.id },
      });
      window.open(jumpUrl.href, "_blank");
    },
    goDetail(item) {
      const jumpUrl = this.$router.resolve({
        path: "/company/detail",
        query: { id: item.id },
      });
      window.open(jumpUrl.href, "_blank");
    },
    async getDetail() {
      const res = await personDetail({ id: this.id });
      if (res && res.data && res.data.code == 200) {
        this.obj = res.data.data;
        this.obj.userImg = `${this.$globalData.imgFile}${this.obj.photo}`;
        if (this.obj.companyId) {
          this.getCompany();
        }
      }
    },
    async getCompany() {
      const res = await companyDetail({ id: this.obj.companyId });
      if (res && res.data && res.data.code == 200) {
        this.gsList = [res.data.data];
      }
    },
    async getBehaviorGood() {
      const res = await personBehavior({
        id: this.id,
        good: 1,
      });
      if (res && res.data && res.data.code == 200) {
        this.goodList = res.data.rows || [];
      }
    },
    async getBehaviorBad() {
      const res = await personBehavior({
        id: this.id,
        good: 0,
      });
      if (res && res.data && res.data.code == 200) {
        this.badList = res.data.rows || [];
      }
    },
  },
};
</script>

<style lang="less">
.per-detail-main-page {
  background: #fff;
  .list-clr {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    .page-right {
      width: 848px;
      .info-bottom {
        line-height: 32px;
      }
      .i-r-t {
        font-size: 16px;
        margin: 20px 0;
      }
      .lab-item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #555;
        font-size: 14px;
        .lab-left {
          width: 170px;
          min-height: 80px;
          flex-shrink: 0;
          border: 1px solid #eee;
          padding: 20px 20px;
          background: #fafafa;
          border-bottom: none;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .lab-right {
          flex: 1;
          min-height: 80px;
          border: 1px solid #eee;
          padding: 20px 20px;
          border-left: none;
          border-bottom: none;
          display: flex;
          align-items: center;
        }
      }
      .lab-row {
        display: flex;
        .lab-item {
          flex: 1;
          &:nth-of-type(2n) {
            .lab-left {
              border-left: none;
            }
          }
          position: relative;
          .user-img-box {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 240px;
            border-right: 1px solid #eee;
            border-top: 1px solid #eee;
          }
          .user-img {
            position: absolute;
            width: 150px;
            height: 200px;
            top: 18px;
            left: 0;
            right: 0;
            margin: auto;
            object-fit: cover;
          }
        }
        &:last-child {
          .lab-left {
            border-bottom: 1px solid #eee;
          }
          .lab-right {
            border-bottom: 1px solid #eee;
          }
        }

        &:nth-last-child(2) {
          & > div:last-child {
            .lab-left {
              border-bottom: 1px solid #eee;
            }
            .lab-right {
              border-bottom: 1px solid #eee;
            }
          }
        }
      }
    }

    .mg-t20 {
      margin-top: 20px;
    }
    #mapBox {
      width: 100%;
      height: 500px;
    }
  }
  .look-remark {
    color: #fff;
    background-color: #b1191a;
    font-size: 18px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 288px;
    height: 46px;
    cursor: pointer;
  }
}
</style>